import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import {
  beforeLoadProtectedWebviewSession,
  loadProtectedWebviewSession,
  retryWebviewAuthOrCloseApp,
} from './protectedWebviewSession'
import { Button } from 'shared/ui/Button'
import { mapViewportIds, type MapViewportId } from 'widgets/map/lib/mapViewports'

function isMapViewportId(value: string): value is MapViewportId {
  return mapViewportIds.includes(value as MapViewportId)
}

export function prefetchFloor6MapRoute() {
  void import('./floor6Map.lazy')
}

export const floor6MapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/floor-6/map/$block',
  errorComponent: ({ error }) => {
    const message = error instanceof Error ? error.message : 'Не удалось открыть карту'

    return (
      <div className="p-5 h-dvh w-full grid place-items-center">
        <div className="flex flex-col items-center gap-3">
          <div className="text-red-600 text-center">{message}</div>
          <Button onClick={retryWebviewAuthOrCloseApp}>Повторить</Button>
        </div>
      </div>
    )
  },
  beforeLoad: async ({ params }) => {
    if (!isMapViewportId(params.block)) {
      throw redirect({ to: '/floor-6/map/$block', params: { block: 'full' } })
    }

    prefetchFloor6MapRoute()
    await beforeLoadProtectedWebviewSession()
  },
  loader: () => loadProtectedWebviewSession({ preloadPlaces: true }),
}).lazy(() => import('./floor6Map.lazy').then((d) => d.floor6MapLazyRoute))
